import script from "./VueSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./VueSelect.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__